module.exports = __webpack_public_path__ + "assets/img/contact-head.b7e48753.png";